/*
 * @Author: qin 15936669602@163.com
 * @Date: 2024-01-24 20:33:08
 * @LastEditors: qin 15936669602@163.com
 * @LastEditTime: 2024-01-24 20:33:21
 * @FilePath: /360-house-viewing-main/src/utils/utils.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
function getIndexToLetter(index) {
  // 确保输入是数字且在有效范围内
  if (typeof index === "number" && index >= 0 && index < 26) {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    return letters[index];
  } else {
    return "Invalid index"; // 或者抛出错误
  }
}

export { getIndexToLetter };
